import { QuoteStatus } from '@graphql';
import { UseNavigateResult } from '@tanstack/react-router';
import { FINANCIAL_PRODUCT } from '@utils/constants';
import { accessibleQuote } from '@utils/helper';

export const handleNavigation = ({
  navigate,
  trackingId,
  quoteStatus,
  hasOpportunityId,
  financialProductId,
  currentPath,
  allowAllQuoteStatusesAccessible = false,
}: {
  navigate: UseNavigateResult<string>;
  trackingId: string;
  quoteStatus?: QuoteStatus;
  hasOpportunityId: boolean;
  financialProductId?: string;
  currentPath?: string;
  allowAllQuoteStatusesAccessible?: boolean;
}) => {
  if (quoteStatus && !allowAllQuoteStatusesAccessible && !accessibleQuote(quoteStatus)) {
    navigate({ to: '/connect/quoteStatus/', search: { trackingId } });
  } else {
    if (financialProductId === FINANCIAL_PRODUCT.CBA_RESIDENTIAL) {
      if (!currentPath?.startsWith('/connect/cba')) {
        return navigate({ to: '/connect/cba/', search: { trackingId } });
      }
    } else if (financialProductId === FINANCIAL_PRODUCT.ELECTRIFY_2515) {
      if (!currentPath?.startsWith('/connect/electrify2515')) {
        return navigate({ to: '/connect/electrify2515/', search: { trackingId } });
      }
    } else if (hasOpportunityId) {
      if (!currentPath?.startsWith('/connect/default')) {
        return navigate({ to: '/connect/default/', search: { trackingId } });
      }
    } else {
      return;
    }
  }
};
